/** Keeps finite numbers; treats null, NaN, Infinity and non-numbers as absent. */
export function toOptionalFiniteNumber(value: unknown): number | undefined {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return undefined;
    }
    return value;
}
